module.exports = __webpack_public_path__ + "static/media/visit.4ebb7ae9.svg";